<!-- <img src="./assets/img/CBBlogo.png" style="width:100%;"  />   <br><br> -->
<div class="card-header new-logo text-white">
           
    <div class="cbob-new-logo-container">
            <img src="./assets/img/CBOB-Official-Logo-SM.jpg" class="cbob-new-logo">
            <h4 class="small">Bond Application Login</h4>
    </div>
</div>
<div  class="card-body">
<h5  style="font-size: 0.9970rem"> <font color="#627076">Reset Password</font></h5>
<form [formGroup]="forgotPassword" name="forgotPassword"
      (ngSubmit)="sendResetEmail(forgotPassword.value)" style="border: transparent;" autocomplete="off">
    <mat-form-field class="w-100 mb-1">
     
              
        <input matInput formControlName="Email" id="Email" id="email" type="text" placeholder="Enter Your User ID">
  
        <mat-error *ngIf="forgotPassword.controls.Email.hasError('required')">
        Customer ID is <strong>required</strong>
        </mat-error> 
            <i *ngIf="_resetFormService.emailPending" class="fa fa-cog fa-spin text-warning field-bottom-right animated fadeIn" aria-hidden="true"></i>
            <i *ngIf="_resetFormService.validEmail && forgotPassword.controls.Email.valid && !_resetFormService.emailPending" class="fa fa-check text-success field-bottom-right animated fadeIn" aria-hidden="true"></i>
            <i *ngIf="!_resetFormService.validEmail && submitted1 && !_resetFormService.emailPending" class="fa fa-times text-danger field-bottom-right animated fadeIn" aria-hidden="true"></i>
    </mat-form-field>

    <mat-form-field class="w-100" *ngIf="_resetFormService.emailhide">
        <input matInput formControlName="EmailOTP" id="EmailOTP"  type="password" placeholder="Enter Emailed One-Time Password">
        <mat-error *ngIf="!forgotPassword.controls.EmailOTP.valid && submitted2">
        Enter Emailed One-Time Password
        </mat-error>
    </mat-form-field>

     <button *ngIf="!_resetFormService.validEmail" mat-flat-button color="primary"  value="Continue" type="button" class="w-100 loginbtn mb-2" (click)="checkEmail(forgotPassword.controls.Email.value);">Continue</button>
     <button *ngIf="_resetFormService.otpvalid" mat-flat-button color="primary"  value="otp" type="button" class="w-100 loginbtn mb-2" (click)="OTPValidate(forgotPassword.controls.EmailOTP.value);">Verify One-Time Password</button>

    <!-- <div class="animated fadeIn" *ngIf="_resetFormService.otpvalidsuccess">      

        <div style="position:relative;">
            <label >  <font color="#0000FF">{{ _resetFormService.questions[_resetFormService.selectedQuestion] }}</font></label>
          
            <mat-icon class="fa fa-exchange " (click)="_resetFormService.switchQuestion()" title="Change Question" aria-hidden="true">swap_horizontal_circle</mat-icon>
       
        </div>

        <mat-form-field class="w-100">
            <input matInput formControlName="Answer" id="Answer" type="text" placeholder="Answer">
            <mat-error *ngIf="!forgotPassword.controls.Answer.valid && submitted2">
            Please enter your answer
            </mat-error>
        </mat-form-field>

        <br>
    </div>
    <button mat-flat-button color="primary" type="submit" class="w-100 loginbtn mb-2"  value="Reset" *ngIf="_resetFormService.otpvalidsuccess">Reset</button> -->
 <!-- <button *ngIf="!_resetFormService.validEmail" mat-flat-button color="primary"  value="Continue" type="button" class="w-100 loginbtn mb-2" (click)="checkEmail(forgotPassword.controls.Email.value);">Continue</button> -->
     <button mat-flat-button  class="width-100"  color="warn" type="button"  value="Cancel" (click)="_resetFormService.forgottenPasswordFormUpdate(false, $event)" >Cancel</button>
</form>
</div>
